// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dashboard-container {\n\n}\n", "",{"version":3,"sources":["webpack://src/pages/About/style.css"],"names":[],"mappings":"AAAA;;AAEA","sourcesContent":[".dashboard-container {\n\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
